import React from "react";
import { Spinner } from "@radix-ui/themes";

/**
 * The app's one "fetching" surface.
 *
 * Loading used to be a `Spinner size="3"` here, a `Spinner size="1"` there,
 * plain italic text somewhere else, and on the mobile sheet nothing at all —
 * the list simply stayed blank until data landed, which reads as "empty" rather
 * than "working".
 *
 * Props:
 *   label    what is being fetched ("Loading customers…")
 *   compact  tighter padding, for use inside a modal or a small panel
 */
export default function LoadingState({ label = "Loading…", compact = false }) {
  return (
    <div className={`empty-state${compact ? " is-compact" : ""}`} role="status" aria-live="polite">
      <Spinner size={compact ? "1" : "2"} />
      <p className="empty-state-title">{label}</p>
    </div>
  );
}
